export default __webpack_public_path__ + "static/media/IMG_9045 copie.947e85e2.jpg";